<div class="col-12">
  <ng-container *ngIf="inputConfig.control; else inputWithoutControl">
    <div class="row">
      <div class="col-12 mb-1">
        <ui-fh-label [info]="this.inputConfig.infoLabel ?? ''" [label]="this.inputConfig.label ?? ''"></ui-fh-label>
      </div>
      <div class="col-12">
        <p-dropdown
          (onShow)="onDropdownOpen()"
          optionLabel="translatedLabel"
          optionValue="value"
          [disabled]="(inputConfig.disabled ?? false) || inputConfig.control.disabled"
          [formControl]="inputConfig.control!"
          [placeholder]="inputConfig.placeholder"
          [class]="class"
          styleClass="z-5 w-100 dropdown-inputs-style py-0"
          class="fh-dropdown-form"
          [options]="list"
          [virtualScroll]="inputConfig.allowHtml"
          [virtualScrollItemSize]="38"
          [filter]="filter"
          [filterBy]="filterField"
          [ngClass]="{
            'dropdown-border': borderClass,
            'p-invalid ng-invalid ng-dirty': inputConfig.control.touched && inputConfig.control.errors,
            'mb-2': !inputConfig.control.errors
          }"
          [editable]="editable">
          <ng-container *ngIf="inputConfig.allowHtml">
            <ng-template pTemplate="selectedItem">
              <div [innerHTML]="getLabelByValue(inputConfig.control.value ?? '')"></div>
            </ng-template>
            <ng-template let-item pTemplate="item">
              <div [innerHTML]="item.label"></div>
            </ng-template>
          </ng-container>
        </p-dropdown>
        <div *ngIf="inputConfig.control?.errors" class="error-message mb-2">
          <small class="p-error block" *ngIf="inputConfig.control?.touched && inputConfig.control?.errors">{{
            inputConfig.control.errors!['error'] | translate
          }}</small>
        </div>
      </div>
    </div>
  </ng-container>
  <ng-template #inputWithoutControl>
    <ng-container>
      <ui-fh-label [labelConfig]="labelConfigs"></ui-fh-label>
      <p-dropdown
        optionLabel="translatedLabel"
        optionValue="value"
        class="fh-dropdown"
        [placeholder]="inputConfig.placeholder ? inputConfig.placeholder : placeholder"
        [class]="inputConfig.class ?? ''"
        [options]="list"
        [(ngModel)]="value"
        [virtualScroll]="inputConfig.allowHtml"
        [virtualScrollItemSize]="38"
        [ngClass]="{ 'dropdown-border': borderClass }"
        [editable]="editable"
        (ngModelChange)="valueChanged()">
      </p-dropdown>
    </ng-container>
  </ng-template>
</div>
